export default "__VITE_ASSET__DOVOSPW$__"